import React from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa'

export default function Package({
    title="paquete de x cosas", 
    description="descripción del paquete",
    content = [
        {text:"ejemplo", productID: "XD"}
    ],
    price= 0,
    img= [

    ]
}) {
    return (
        <div className="column is-6">
        <div className="box">
        
        <p className="title is-4">{title}</p>
            <p className="subtitle is-5">{title}</p>
            <div className="content">
                Contiene:
                <ul className="mt-0">
                {
                    content.map( item => 
                    <li>
                        {item.text}
                    </li>)
                }
                </ul>
            </div>
           <div class="field has-addons">
                <p class="control">
                    <button class="button">
                        <span><FaPlus/></span>
                    </button>
                </p>
                <p className="control">
                    <span className="button is-static">0</span>
                </p>
                <p class="control">
                    <button class="button">
                        <span><FaMinus/></span>
                    </button>
                </p>
            </div>

        </div>
        </div>
    )
}
